module.exports = __webpack_public_path__ + "static/sample-23-e5baa8a592a53de4ecf66b9a082181fc.png";